module.exports = __webpack_public_path__ + "static/media/3 06 Tulleord Flynt er feil.c503363e.mp3";